import { getLocalStorageData } from '@/utils/LocalStorage';
import { getFromSessionStorage } from '@/utils/SessionStorage';

export const useCustomerId = () => {
  const customerId =
    getLocalStorageData('tabsOpen') === 1
      ? getLocalStorageData('currentCustomerID')
      : getFromSessionStorage('currentCustomerID') || getLocalStorageData('currentCustomerID');

  return customerId;
};

export const useSiteId = () => {
  const siteId =
    getLocalStorageData('tabsOpen') === 1
      ? getLocalStorageData('currentSiteID')
      : getFromSessionStorage('currentSiteID') || getLocalStorageData('currentSiteID');
  return siteId;
};
